import Vue from 'vue'
import Router from 'vue-router'

import PortfolioListPage from './views/PortfolioListPage.vue'
import PortfolioPage from './views/PortfolioPage.vue'
import TrendingPage from './views/TrendingPage.vue'
import CoingeckoIdLookupPage from './views/CoingeckoIdLookupPage.vue'

Vue.use(Router)

export default new Router({
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/trending',
            component: TrendingPage
        },
        {
            path: '/coinLookup',
            component: CoingeckoIdLookupPage
        },
        {
            path: '/',
            component: PortfolioListPage
        },
        {
            path: '/portfolio/:sheetsId/:sheetsTab',
            component: PortfolioPage
        },
        {
            path: '/portfolio/full',
            component: PortfolioPage
        },
        {
            path: '/portfolio/:sheetsId',
            component: PortfolioPage
        },
        {
            path: '*',
            redirect: '/'
        },
    ]
})
